import { createSelector } from 'reselect'

export const selectQuery = createSelector([state => state.router.location.query], query => query)
